/**
 * Textos de ejemplo del prototipo para revisar el estado «No contratado» con datos simulados (`?estado=no-contratado`).
 * El menú ya dice qué bloque falta (`entitlement`, G120), pero el contrato aún no da el nombre comercial del bloque ni lo
 * que incluye (P0-7, pendiente del equipo): al llegar, saldrá de la API y esto se borra.
 */
export const BLOQUE_DE_EJEMPLO = {
    nombre: 'Mensajes y campañas',
    incluye: ['Campañas por email y WhatsApp a tus clientes', 'Mensajes automáticos tras una visita', '2.000 envíos al mes incluidos'],
} as const;
